// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-method-icons {
  display: flex;
  justify-content: space-evenly;
  align-items: center;

  margin: 0 auto;
}

.payment-method-icons .icon-container {
  display: flex;
  width: 26px;

  justify-content: center;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.payment-method-icons.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;;EAEnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;;EAEX,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".payment-method-icons {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n\n  margin: 0 auto;\n}\n\n.payment-method-icons .icon-container {\n  display: flex;\n  width: 26px;\n\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
